import { selectCurrentCommittedProposalId } from 'store/proposals/committed';
import { FlightParams } from '../flights.types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './committedFlights.consts';
import { normalizeDateFromApi } from 'helpers/datetimeHelpers';

function normalizeApiReponse(data: FlightParams) {
  const startDate = normalizeDateFromApi(data.timedProductValue.startDate);
  const endDate = normalizeDateFromApi(data.timedProductValue.endDate);
  return {
    ...data,
    timedProductValue: { ...data.timedProductValue, startDate, endDate },
  };
}

export const fetchAllCommittedFlightsOfProposal = createAsyncThunk(
  REDUCER_KEY + '/getCommitted',
  withErrorHandling(async ({ proposalId }: { proposalId: number }) => {
    const response = await adserver({
      url: `/proposal/${proposalId}/committed/flights`,
      headers: {},
    });

    const surcharges = await adserver({
      url: `/proposal/${proposalId}/surcharges`,
      headers: {},
    });

    return response.data.map((flight: FlightParams) => {
      return {
        ...normalizeApiReponse({
          ...flight,
          proposalId,
        }),
        surcharges: surcharges?.data,
      };
    });
  }),
);

export const fetchAllCommittedFlightsForCurrentProposal = createAsyncThunk(
  REDUCER_KEY + '/fetchAllCommittedFlightsForCurrentProposal',
  withErrorHandling(async (_: any, thunkApi: any) => {
    const proposalId = selectCurrentCommittedProposalId(thunkApi.getState());
    const response = await adserver({
      url: `/proposal/${proposalId}/committed/flights`,
      headers: {},
    });

    const surcharges = await adserver({
      url: `/proposal/${proposalId}/surcharges`,
      headers: {},
    });

    return response.data.map((flight: FlightParams) => {
      return {
        ...normalizeApiReponse({
          ...flight,
          proposalId,
        }),
        surcharges: surcharges?.data,
      };
    });
  }),
);

export const removeAllFlights = (): { type: string } => ({
  type: REDUCER_KEY + '/removeAll',
});
